import { Pipe, PipeTransform } from '@angular/core';
import Keycloak from 'keycloak-js';

@Pipe({
    name: 'userAccess',
    standalone: false
})
export class UserAccessPipe implements PipeTransform {
  constructor(
    private keycloakAngular: Keycloak
  ) { }

  transform(role: string, ...args: any[]): any {
    return this.keycloakAngular.loadUserProfile().then(({ attributes }: any) => {
      if (attributes[role]) {
        return attributes[role][0] == 'true';
      } else {
        return false;
      }
    });

  }

}
